// extracted by mini-css-extract-plugin
export default {"section":"Partners_section__Z91OI","title":"Partners_title__bLWXQ","container":"Partners_container__nkZif","logo":"Partners_logo__KRqws"};